import * as React from 'react'

export interface ImageType {
  alt?: string
  url?: string
}

interface PersonalisationToggleInterface {
  isPersonalisationActive: boolean
  setIsPersonalisationActive: React.Dispatch<React.SetStateAction<boolean>>
  variantSku: string
  setVariantSku: React.Dispatch<React.SetStateAction<string>>
  personalisationFields: {}
  setPersonalisationFields: React.Dispatch<React.SetStateAction<{}>>
  personalisationImagesContext: {
    key: string
    images: ImageType[]
    thumbnails: ImageType[]
    zoom: ImageType[]
  }
  setPersonalisationImagesContext: React.Dispatch<
    React.SetStateAction<{
      key: string
      images: ImageType[]
      thumbnails: ImageType[]
      zoom: ImageType[]
    }>
  >
}

export const PersonalisationToggleContext = React.createContext<
  PersonalisationToggleInterface
>({
  isPersonalisationActive: false,
  setIsPersonalisationActive: () => {},
  variantSku: '',
  setVariantSku: () => {},
  personalisationFields: {},
  setPersonalisationFields: () => {},
  personalisationImagesContext: {
    key: '',
    images: [{ alt: '', url: '' }],
    thumbnails: [{ alt: '', url: '' }],
    zoom: [{ alt: '', url: '' }],
  },
  setPersonalisationImagesContext: () => {},
})

export const usePersonalisationToggleContext = () =>
  React.useContext(PersonalisationToggleContext)
